import {firstValueFrom, Observable, timeout} from 'rxjs';

export interface EmployeeAddress {
 street: string; postalCode: string; city: string; 
}
export interface EmployeeCoordinates {
 latitude: number; longitude: number; 
}
export function validEmployeeCoordinates(value: EmployeeCoordinates | null | undefined): boolean {
  return !!value && Number.isFinite(value.latitude) && Number.isFinite(value.longitude)
    && Math.abs(value.latitude) <= 90 && Math.abs(value.longitude) <= 180;
}

/** Existing users.address is the source; users.location is its nullable derived cache. */
export async function resolveEmployeeCoordinates(
  previous: {address?: EmployeeAddress; location?: EmployeeCoordinates | null},
  address: EmployeeAddress,
  geocode: (street: string, postalCode: string, city: string) => Observable<EmployeeCoordinates | null>,
): Promise<EmployeeCoordinates | null> {
  const unchanged = ['street', 'postalCode', 'city'].every(key => previous.address?.[key] === address[key]);
  if (unchanged && validEmployeeCoordinates(previous.location)) {
    return previous.location;
  }
  if (!address.street.trim() || (!address.postalCode.trim() && !address.city.trim())) {
    return null;
  }
  try {
    // The existing geocoder builds its URL directly; encode each value once.
    const result = await firstValueFrom(geocode(encodeURIComponent(address.street.trim()),
      encodeURIComponent(address.postalCode.trim()), encodeURIComponent(address.city.trim())).pipe(timeout(8000)));
    return validEmployeeCoordinates(result) ? result : null;
  } catch {
    // Failed derivation must neither reject the human-readable address nor keep stale coordinates.
    return null;
  }
}
